import { Panel, PanelBorderRadius, PanelTheme } from '@apply/components';
import { formatCurrency } from '@apply/ui';
import { RequestDrawButton } from './components/RequestDrawButton/RequestDrawButton';
import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { DrawApi } from '@apply/api';
import { DrawAddressLink } from './components/DrawAddressLink';
import { ViewDrawButton } from './components/RequestDrawButton/components/ViewDrawButton';

interface AddDrawCardProps {
    dashboardDrawBudget: IDashboardDrawBudget;
    set_modalDashboarDrawBudget: React.Dispatch<React.SetStateAction<DrawApi.IDashboardDrawBudget | undefined>>;
}
export const AddDrawCard: React.FC<AddDrawCardProps> = ({ dashboardDrawBudget, set_modalDashboarDrawBudget }) => {
    return (
        <div className='draw-add-container'>
            <div className='row '>
                <DrawAddressLink dashboardDrawBudget={dashboardDrawBudget} />
                <div className='panelBadge'>
                    {dashboardDrawBudget.isOutOfBalance && !dashboardDrawBudget.isOutOfBalanceWaived ? (
                        <Panel
                            theme={PanelTheme.Red}
                            padding={5}
                            borderRadius={PanelBorderRadius.Medium}
                        >
                            Out of Balance
                        </Panel>
                    ) : (
                        ''
                    )}
                </div>
            </div>
            <div className='row'>
                <div className='numbers'>
                    <div>
                        <div className='label'>Committed:</div>
                        <div className='value'>{formatCurrency(dashboardDrawBudget.committed)}</div>
                    </div>
                    <div>
                        <div className='label'>Funded:</div>
                        <div className='value'>{formatCurrency(dashboardDrawBudget.funded)}</div>
                    </div>
                    <div className='available-container'>
                        <div className='available-text'>
                            <div className='label'>Available:</div>
                            <div className='value available'>{formatCurrency(dashboardDrawBudget.available)}</div>
                        </div>
                        <div className='available-button'>
                            <ViewDrawButton
                                drawBudgetId={dashboardDrawBudget.drawBudgetId}
                                drawHistoryLines={dashboardDrawBudget.drawHistoryLines}
                            />
                            <RequestDrawButton
                                dashboardDrawBudget={dashboardDrawBudget}
                                set_modalDashboarDrawBudget={set_modalDashboarDrawBudget}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
